
export const API_CONFIG = {
    baseUrl: process.env.REACT_APP_apiUri ? process.env.REACT_APP_apiUri : "http://localhost:4000/api/v1/",
}
